import { useState } from "react";
import AuthComp from "../component/AuthComp";
import SelectType from "../component/SelectType";
import FormRegister from "../component/RegisterCom/Form";
import ListGroup from "../component/ListGroup";
function Register() {
    const [type, setType] = useState('selectUser');
    const [isStore, setIsStore] = useState(false);
    const [typeStore, setTypeStore] = useState('0');

    const handleClick = (val) => {
        setType(val);
    }
    return (
        <>
            <ListGroup />
            <AuthComp type={type} setType={setType} page="register" isStore={isStore} setIsStore={setIsStore} setTypeStore={setTypeStore} arrowBack>
                {type === 'selectUser' ?
                    <SelectType type={type} setType={setType} handleClick={handleClick} page="register" />
                    :
                    <FormRegister type={type} setType={setType} isStore={isStore} setIsStore={setIsStore} typeStore={typeStore} setTypeStore={setTypeStore} />
                }
            </AuthComp>

        </>
    );
}

export default Register;
